import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { SubscriptionInfoPublic } from '../fragments';

export default gql`
  mutation actionSubscriptionCancel($input: SubscriptionCancelActionInput!) {
    actionSubscriptionCancel(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      subscription {
        ...SubscriptionInfoPublic
      }
    }
  }
  ${SubscriptionInfoPublic}
  ${ErrorMessageInfo}
`;
